const componentInfo = {
  name: "Fragment",
  static: true,
  hidden: true,
  canHaveChildren: true,
  noWrap: true
};
export {
  componentInfo
};
